import { useQueryClient } from '@tanstack/react-query';
import { useSignalREffect } from '../../signalr/SignalRContext';
import {
  Classroom,
  ClassroomPositionsNotification,
  ClassroomUsersNotification,
  SimulationEventMessage,
} from '../../types';
import { useActiveCompany } from '../../utils/useCompany';

export const useSignalRClassroom = () => {
  const queryClient = useQueryClient();
  const activeCompany = useActiveCompany();

  useSignalREffect(
    SimulationEventMessage.ClassroomPositions,
    (...args) => {
      const exerciseId = args[0] as string;
      const notification = args[1] as ClassroomPositionsNotification;
      console.debug('classroomPositions', notification);

      queryClient.setQueryData<Classroom>(
        [{ path: `teach/companies/${activeCompany?.companyId}/scheduled-exercises/${exerciseId}/classroom` }],
        classroom => {
          if (!classroom) {
            return;
          }

          return {
            ...classroom,
            positions: notification,
          };
        },
      );
    },
    [],
  );

  useSignalREffect(
    SimulationEventMessage.ClassroomUsers,
    (...args) => {
      const exerciseId = args[0] as string;
      const notification = args[1] as ClassroomUsersNotification;
      console.debug('classroomUsers', notification);

      queryClient.setQueryData<Classroom>(
        [{ path: `teach/companies/${activeCompany?.companyId}/scheduled-exercises/${exerciseId}/classroom` }],
        classroom => {
          if (!classroom) {
            return;
          }

          return {
            ...classroom,
            students: notification,
          };
        },
      );
    },
    [],
  );
};
